import { Component, HostListener, inject } from '@angular/core';
import { RouterLinkActive, RouterModule, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { JADHU_NAV_ITEMS, LANGUAGES } from '../../../shared/configs';
import { JadhuLanguage } from '../../../shared/models';

@Component({
  selector: 'app-navbar',
  imports: [RouterModule, TranslateModule, RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})

export class NavbarComponent {
  private readonly translate = inject(TranslateService);
  readonly navItems = JADHU_NAV_ITEMS;
  readonly languages: JadhuLanguage[] = LANGUAGES;

  scrolled = false;
  mobileOpen = false;

  selectedLanguage = 'en';

  constructor() {
    const currentLanguage = this.translate.currentLang;

    if (currentLanguage) {
      this.selectedLanguage = currentLanguage;
    }
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 30;
  }

  toggle(): void {
    this.mobileOpen = !this.mobileOpen;
  }

  close(): void {
    this.mobileOpen = false;
  }

  changeLanguage(language: JadhuLanguage): void {
    this.selectedLanguage = language.code;
    this.translate.use(language.code);
    this.close();
  }
}
